<template>
  <div class="link-views no-bg">
    <div class="bg-div">
      <span style="display:none;">{{isExpID}}</span>
      <div class="top">
        <Button type="primary" @click="goback">返回</Button>
      </div>
      <Row :gutter="16" class="hasImgDiv" type="flex">
        <i-col :xs="24" :sm="24" :md="24" :lg="8" :xxl="6">
          <div v-if="virtualDetails.ExpShow">
            <div class="flImg" v-if="virtualDetails.ExpShow.split(',').length>1">
              <Carousel v-model="value1" loop>
                <CarouselItem
                  v-for="(item,index) in virtualDetails.ExpShow.split(',')"
                  :key="index"
                >
                  <div class="demo-carousel">
                    <img :src="port+item" alt>
                  </div>
                </CarouselItem>
              </Carousel>
            </div>
            <div class="flImg" v-else>
              <img v-if="virtualDetails.ExpPicUrl" :src="port+virtualDetails.ExpPicUrl" alt>
            </div>
          </div>
          <div class="flImg" v-else>
            <img v-if="virtualDetails.ExpPicUrl" :src="port+virtualDetails.ExpPicUrl" alt>
          </div>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="16" :xxl="18" class="flex-column">
          <div>
            <strong class="p10">{{virtualDetails.ExpName}}</strong>
            <span class="small ml">实验ID：{{virtualDetails.ExpID}}</span>
          </div>
          <div class="flexDiv flex1">
            <div>实验简介</div>
            <div class="flex1">
              <div>{{virtualDetails.Abstract}}</div>
            </div>
          </div>
          <div class="btnBox">
      

            <router-link :to="{name:'visitorMaterials',params:{id:$route.params.id}}">
              <Button type="primary">学习资料</Button>
            </router-link>

            <a href="javascript:void(0)" @click="enterExpUrl(isExpID)">
              <Button type="primary">进入实验</Button>
            </a>

      
          </div>
        </i-col>
      </Row>
    </div>
    <!--Video  -->
    <div class="bg-div VideoBox" style="margin:20px 0;">
      <Row class="VideoDiv top" type="flex">
        <i-col
          :xs="{ span: 24, offset: 0 }"
          :md="{ span: 12, offset: 6 }"
          v-if="VideoBtn==1"
          style="margin-top:20px"
        >
          <video
            v-if="virtualDetails.DecVideoUrl"
            :src="port+virtualDetails.DecVideoUrl"
            controls="controls"
          ></video>
          <div v-else class="text-center p10">暂无相关视频</div>
        </i-col>
        <i-col
          :xs="{ span: 24, offset: 0 }"
          :md="{ span: 12, offset: 6 }"
          v-if="VideoBtn==2"
          style="margin-top:20px"
        >
          <video
            v-if="virtualDetails.DirVideoUrl"
            :src="port+virtualDetails.DirVideoUrl"
            controls="controls"
          ></video>
          <div v-else class="text-center p10">暂无相关视频</div>
        </i-col>
      </Row>
      <div class="VideoBtn">
        <div>
          <span :class="{'on':VideoBtn==1}" @click="changeVideoBtn(1)">申报视频</span>
          <span :class="{'on':VideoBtn==2}" @click="changeVideoBtn(2)">教学引导视频</span>
        </div>
      </div>
    </div>
    <!-- 饼图 -->
    <Row :gutter="16" type="flex">
      <i-col :xs="24" :sm="24" :md="24" :lg="12">
        <div class="result">
          <div class="resultTitle">访问人数统计</div>
          <div>
            <div class="resultInfo">
              <ve-line
                :grid="{left:16,right:36}"
                :judge-width="true"
                :data="chartData1"
                :settings="chartSettings1"
                :extend="chartExtend1"
                :data-empty="dataEmpty1"
              ></ve-line>
            </div>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="12">
        <div class="result">
          <div class="resultTitle">访问时长与得分统计</div>
          <div>
            <div class="resultInfo">
              <ve-histogram
                :grid="{left:36,right:36}"
                :judge-width="true"
                :data="chartData2"
                :settings="chartSettings2"
                :extend="chartExtend2"
                :data-empty="dataEmpty2"
              ></ve-histogram>
            </div>
          </div>
        </div>
      </i-col>
    </Row>
    <!-- 成绩列表 -->
    <div class="bg-div">
      <Table :columns="columnsStu" :data="stuListObj.Result"></Table>
      <div class="page-div">
        <Page
          v-if="stuListObj.records>stuPageData.size"
          show-total
          :total="stuListObj.records"
          :current="stuPageData.page"
          :page-size="stuPageData.size"
          @on-change="stuchangePage"
        />
      </div>
    </div>
    <!--团队列表 -->
    <div class="bg-div" style="margin:20px 0;">
      <strong>实验教学队伍团队</strong>
      <div class="my-carousel-card" ref="hello" v-if="TeamList.length>0">
        <Carousel v-model="value2" dots="outside" arrow="hover">
          <CarouselItem v-for="(item,index) in TeamList" :key="index">
            <div class="demo-carousel-card" v-for="(obj,n) in item" :key="n">
              <Card>
                <div @mousemove="enter(obj)">
                  <div>
                    <img :src="port+obj.ImageUrl" style="display:block;width:100%;">
                  </div>
                  <div class="cardText">
                    <Tooltip :content="obj.Name" placement="top">
                      <div class="text-overflow">{{obj.Name}}</div>
                    </Tooltip>
                    <Tooltip :content="obj.Academy" placement="top">
                      <div class="text-overflow">{{obj.Academy}}</div>
                    </Tooltip>
                    <Tooltip :content="obj.TheTitle" placement="top">
                      <div class="text-overflow">{{obj.TheTitle}}</div>
                    </Tooltip>
                    <Tooltip :content="obj.TakeCharge" placement="top">
                      <div class="text-overflow">{{obj.TakeCharge}}</div>
                    </Tooltip>
                  </div>
                </div>
              </Card>
            </div>
          </CarouselItem>
        </Carousel>
        <div class="demo-carousel-info" v-if="showCard" @mouseout="leave()">
          <div>{{showCardItem.Details}}</div>
        </div>
      </div>
      <div v-else class="nodata m10">暂无数据</div>
    </div>
    <!-- 错误步骤及留言评分 -->
    <Row :gutter="16" type="flex">
      <i-col :xs="24" :sm="24" :md="24" :lg="8">
        <div class="result gradeMessage">
          <div class="resultTitle">错误步骤说明（top15）</div>
          <div class="resultInfo">
            <Table :columns="columns" :data="virtualDetails.StateTop"></Table>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="16">
        <div class="result gradeMessage grade">
          <!-- 头部 -->
          <div class="gradeTitle">
            综合评价
            <span class="ml">
              <Rate v-model="gradeListObj.Mean" disabled/>
            </span>
          </div>
          <!-- 评价列表 -->
          <div class="gradeInfo-div">
            <div v-if="gradeListObj.records>0">
              <div class="p10 gradeInfo" v-for="(item,index) in gradeListObj.Result" :key="index">
                <div class="leftSide">
                  <div class="text-overflow">{{item.UserName}}</div>
                  <div class="rate">
                    <Rate disabled v-model="item.DisScore"/>
                  </div>
                </div>
                <div class="rightSide">
                  <div class="info small">{{item.Content}}</div>
                  <div class="time">{{item.CreateTime}}</div>
                </div>
              </div>
            </div>
            <div v-else class="nodata m10">暂无留言</div>
          </div>
          <!-- 分页 -->
          <div class="page-div">
            <Page
              v-if="gradeListObj.records>gradePageData.size"
              show-total
              :total="gradeListObj.records"
              :current="gradePageData.page"
              :page-size="gradePageData.size"
              @on-change="gradechangePage"
            />
          </div>
          <!-- 评分 -->
          <div class="evaluate-div">
            <div class="gradeTitle">综合评价</div>
            <div class="p10 gradeInfo">
              <div class="leftSide">
                <div class="num">{{submitObj.DisScore}}</div>
                <div class="rate">
                  <Rate v-model="submitObj.DisScore"/>
                </div>
              </div>
              <div class="rightSide onlyRate">
                <Rate v-model="submitObj.DisScore" @on-change="changeDisScore"/>
              </div>
            </div>
          </div>
          <!-- 评语 -->
          <div class="top">
            <Input v-model="submitObj.Content" type="textarea" :rows="4" placeholder="欢迎留言..."/>
          </div>
          <div class="text-right">
            <i-button type="primary" @click="submitFn" disabled>提交</i-button>
          </div>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/visitor-api.js";
import * as publicApi from "../../../api/public-api.js";
import * as allFn from "../../../utils/index.js";
import VeHistogram from "v-charts/lib/histogram.common.js";

export default {
  name: "virtual",
  components: {
    VeHistogram
  },
  data() {
    this.chartExtend1 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "<br/>" +
            params[0].seriesName +
            "：" +
            params[0].data[1] +
            "人" +
            "<br/>" +
            params[1].seriesName +
            "：" +
            params[1].data[1] +
            "人" +
            "<br/>" +
            params[2].seriesName +
            "：" +
            params[2].data[1] +
            "人" +
            "<br/>" +
            params[3].seriesName +
            "：" +
            params[3].data[1] +
            "人"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings1 = {
      labelMap: {
        SCount: "学生",
        TCount: "教师",
        YCount: "游客",
        AllCount: "全部"
      },
      yAxisName: ["人数"]
    };
    this.chartExtend2 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "<br/>" +
            params[0].seriesName +
            "：" +
            params[0].data +
            "min" +
            "<br/>" +
            params[1].seriesName +
            "：" +
            params[1].data +
            "min" +
            "<br/>" +
            params[2].seriesName +
            "：" +
            params[2].data +
            "min" +
            "<br/>" +
            params[3].seriesName +
            "：" +
            params[3].data +
            "分"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings2 = {
      labelMap: {
        SLength: "学生",
        TLength: "教师",
        YLength: "游客",
        Score: "平均成绩"
      },
      showLine: ["Score"],
      axisSite: { right: ["平均得分"] },
      yAxisName: ["平均时长（min）", "平均得分"]
    };
    return {
      port: homeConst.baseUrl + "/", //baseurl
      //虚拟实验详情
      value1: 0,
      value2: 0,
      VideoBtn: 1,
      showCard: false,
      showCardItem: {},
      columnsStu: [
        { title: "姓名", key: "UserName", align: "center" },
        { title: "学号", key: "STYId", align: "center" },
        { title: "班级", key: "ClassName", align: "center" },
        { title: "类型", key: "STYType", align: "center" },
        { title: "开始时间", key: "StartTime", align: "center" },
        { title: "结束时间", key: "EndTime", align: "center" },
        { title: "分数", key: "Score", align: "center" }
      ],
      columns: [
        //错误步骤
        {
          title: "步骤",
          key: "ExpStepName",
          tooltip: true
        },
        {
          title: "次数",
          key: "Count",
          width: 64,
          align: "center"
        }
      ],
      stuPageData: {
        ExpID: "",
        page: 1,
        size: 10
      },
      stuListObj: {
        Result: []
      },
      TeamList: [],
      virtualDetails: {
        ExpShow: ""
      },
      gradePageData: {
        ExpID: "",
        page: 1,
        size: 4
      },
      gradeListObj: {
        Result: []
      },
      ExpID: 0,
      chartData1: {},
      dataEmpty1: true,
      chartData2: {},
      dataEmpty2: true,
      submitObj: {
        ExpID: null,
        DisScore: 0,
        Content: ""
      }
    };
  },
  mounted() {
    this.ExpID = this.$route.params.id;
    this.submitObj.ExpID = this.$route.params.id;
  },
  watch: {
    ExpID(val) {}
  },
  computed: {
    isExpID() {
      this.VideoBtn = 1;
      this.ExpID = this.$route.params.id;
      this.submitObj.ExpID = this.$route.params.id;
      this.getItemById(this.ExpID);
      this.GetScoreList(this.ExpID);
      this.GetExpDecTeamList(this.ExpID);
      this.GetDiscussList(this.ExpID);
      return this.$route.params.id;
    }
  },
  methods: {
    // 获取当前项目
    getItemById(ExpID) {
      // 获取虚拟信息统计
      homeApi
        .GetExperiment({
          ExpID: ExpID
        })
        .then(res => {
          this.virtualDetails = res;
          if (res.Count) {
            this.chartData1 = {
              columns: ["Time", "SCount", "TCount", "YCount", "AllCount"],
              rows: res.Count.reverse()
            };
            this.dataEmpty1 = false;
          } else {
            this.chartData1 = {
              columns: ["Time", "SCount", "TCount", "YCount", "AllCount"],
              rows: []
            };
            this.dataEmpty1 = true;
          }
          if (res.TimeLength) {
            this.chartData2 = {
              columns: ["Time", "SLength", "TLength", "YLength", "Score"],
              rows: res.TimeLength.reverse()
            };
            this.dataEmpty2 = false;
          } else {
            this.chartData2 = {
              columns: ["Time", "SLength", "TLength", "YLength", "Score"],
              rows: []
            };
            this.dataEmpty2 = true;
          }
        });
    },
    // 获取仿真实验成绩列表
    GetScoreList(ExpID) {
      homeApi
        .GetScoreList({
          ExpID: ExpID,
          page: this.stuPageData.page ? this.stuPageData.page : 1,
          size: 10
        })
        .then(res => {
          this.stuListObj = res;
        });
    },
    // 获取团队成员列表
    GetExpDecTeamList(ExpID) {
      homeApi
        .GetExpDecTeamList({
          ExpID: ExpID
        })
        .then(res => {
          this.prolist = res;
          var result = [];
          for (var i = 0; i < res.length; i += 5) {
            result.push(res.slice(i, i + 5));
          }
          this.TeamList = result;
        });
    },
    //进入实验链接

    enterExpUrl(ExpID) {
      var newWindow = window.open();
      publicApi.GetExpUrl({ ExpID: ExpID }).then(res => {
        var enterExpUrlHref;
        if (res.ExpUrl) {
           console.log(res.ExpUrl)
          if (res.ExpUrl.indexOf("http") == -1) {
            enterExpUrlHref = this.port + res.ExpUrl + "?token=" + res.ExpToken;
          } else {
            enterExpUrlHref = res.ExpUrl + "?token=" + res.ExpToken;
          }
        }
        newWindow.location.href = enterExpUrlHref;
      });
    },
    // 评语列表
    GetDiscussList(ExpID) {
      publicApi
        .GetDiscussList({
          ExpID: ExpID,
          page: this.gradePageData.page ? this.gradePageData.page : 1,
          size: this.gradePageData.size
        })
        .then(res => {
          this.gradeListObj = res;
        });
    },
    // 返回
    goback() {
      this.$router.push({
        name: `fkvirtualSimulation`
      });
    },
       // 学习资料
    govisitorMaterials() {
      this.$router.push({
        name: `visitorMaterials`
      });
    },
    // 视频tab切换
    changeVideoBtn(num) {
      this.VideoBtn = num;
    },
    // 成绩分页
    stuchangePage(page) {
      this.stuPageData.page = page;
      this.GetScoreList(this.ExpID);
    },
    // 评分分页
    gradechangePage(page) {
      this.gradePageData.page = page;
      this.GetDiscussList(this.ExpID);
    },
    // 获取评分值
    changeDisScore(val) {
      this.submitObj.DisScore = val;
    },
    // 查看团队队员详情
    enter(item) {
      this.showCardItem = item;
      this.showCard = true;
    },
    // 离开团队队员详情
    leave() {
      this.showCardItem = {};
      this.showCard = false;
    },
    // 添加评分
    submitFn() {
      publicApi.AddDiscuss(this.submitObj).then(res => {
        this.gradePageData.page = 1;
        this.GetDiscussList(this.ExpID);
      });
    }
  }
};
</script>

<style scoped>
</style>